import axios from "@/axios.js";

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("API/Lookup/AddOrUpdateInternalRegulation", item)
        .then(response => {
          debugger;
          resolve(response);
          commit(
            "ADD_ITEM",
            Object.assign(item, { Id: response.data.data.id})
          );
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchDataListItems({ commit }) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .get("API/Lookup/GetInternalRegulation")
        .then(response => {
          resolve(response);
          debugger;
          commit("SET_InternalRegulation", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeItem({ commit }, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios.delete("API/Lookup/DeleteInternalRegulation?Id="+item.id)
        .then((response) => {
          commit('REMOVE_ITEM', item.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
};
